export default "__VITE_ASSET__B8zmki83__"